import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=1d304b34"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"
import style0 from "./Thread.vue?vue&type=style&index=0&id=1d304b34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports